import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-manage-address',
  templateUrl: './e-manage-address.component.html',
  styleUrls: ['./e-manage-address.component.css']
})
export class EManageAddressComponent implements OnInit {

  constructor() { }

  toggle(x:any){
    if(x == 1){
      document.getElementById("selected1").style.borderColor = "green";
      document.getElementById("selected2").style.borderColor = "grey"
    }else{
      document.getElementById("selected2").style.borderColor = "green";
      document.getElementById("selected1").style.borderColor = "grey";
    }
  }

  ngOnInit(): void {

  }

}
